import React, { useRef } from 'react';
import QRCode from 'react-qr-code';
import { Paper, Typography, Box, Button } from '@mui/material';


const TenantQRCodes = ({ tenantId, facilityId }) => {
  let registrationUrl = '';

  if (facilityId) {
    registrationUrl = `${window.location.origin}/visitor-qr-registration?facilityId=${facilityId}`;
  } else if (tenantId) {
    registrationUrl = `${window.location.origin}/visitor-qr-registration?tenantId=${tenantId}`;
  }
  if (!registrationUrl) return null;

  const svgRef = useRef();

  // Convert SVG to PNG and trigger download
  const handleDownload = () => {
    const svg = svgRef.current;
    if (!svg) return;
    const serializer = new XMLSerializer();
    const svgString = serializer.serializeToString(svg);
    const canvas = document.createElement('canvas');
    const size = 180;
    canvas.width = size;
    canvas.height = size;
    const ctx = canvas.getContext('2d');
    const img = new window.Image();
    const svgBlob = new Blob([svgString], { type: 'image/svg+xml;charset=utf-8' });
    const url = URL.createObjectURL(svgBlob);
    img.onload = function () {
      ctx.drawImage(img, 0, 0, size, size);
      URL.revokeObjectURL(url);
      const pngUrl = canvas.toDataURL('image/png');
      const link = document.createElement('a');
      link.href = pngUrl;
      link.download = facilityId
        ? 'facility-visitor-registration-qr.png'
        : 'tenant-visitor-registration-qr.png';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    };
    img.src = url;
  };

  return (
    <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
      <Typography variant="h6">Visitor Registration QR Code</Typography>
      <Paper elevation={3} sx={{ p: 2, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Box sx={{ background: '#fff', p: 1 }}>
          <QRCode value={registrationUrl} size={180} ref={svgRef} />
        </Box>
        <Typography variant="body2" sx={{ mt: 2, wordBreak: 'break-all' }}>{registrationUrl}</Typography>
        <Button
          sx={{ mt: 2 }}
          variant="outlined"
          onClick={handleDownload}
        >
          Download QR Code
        </Button>
      </Paper>
    </Box>
  );
};

export default TenantQRCodes;
